














import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ProgressCircle extends Vue {
    @Prop({type: Number, default: 100}) readonly percentage!: number
    @Prop({type: Number, default: 75}) readonly size!: number
    @Prop({type: Number, default: null}) readonly denominator!: number
    @Prop({type: Boolean, default: false}) readonly fractions!: boolean

    get style(): object {
        return {
            '--percentage': this.percentage,
            '--degrees': ((360 / 100 * this.percentage) / 2) + 'deg',
            '--size': this.size + 'px',
            '--size-half': (this.size / 2) + 'px',
        }
    }

    get fraction(): number[] {
        if (this.denominator) {
            return this.fractionalize(
                Math.round(this.denominator / 100 * this.percentage),
                this.denominator,
            )
        }

        return this.fractionalize(this.percentage, 100)
    }

    fractionalize(numerator, denominator): number[] {
        if (this.percentage === 100 && this.denominator) {
            return [this.denominator, this.denominator]
        }

        if (this.percentage === 0 && this.denominator) {
            return [0, this.denominator]
        }

        let commonDivisor = this.gcd(numerator, denominator)

        if (this.denominator) {
            while (denominator / commonDivisor < this.denominator) {
                commonDivisor = commonDivisor / 2
            }
        }

        return [numerator / commonDivisor, denominator / commonDivisor]
    }

    gcd(a, b): number {
        return b ? this.gcd(b, a % b) : a
    }
}

